import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  DivisionalPromotionEventData,
  DivisionalPromotionExpansionClickData,
  DivisionalPromotionProduct,
  DivisionalPromotionProductClickData,
  DivisionalPromotionSectionHeaders,
  DivisionalPromotionSortingClickData,
  SellerShowcaseDivisionalPromotion,
} from '@app/seller-showcase/models/seller-showcase.model';
import { PlatformService } from '@panamax/app-state';
import { SortableSectionHeader } from '@shared/components/sortable-section/models/sortable-section.model';
import { UsfProductCardModeEnum } from '@shared/constants/usf-product-card-mode.enum';
import { QuantityUpdate } from '@shared/models/quantity-update';

@Component({
  selector: 'app-seller-showcase-divisional-promotion',
  templateUrl: './seller-showcase-divisional-promotion.component.html',
  styleUrls: ['./seller-showcase-divisional-promotion.component.scss'],
})
export class SellerShowcaseDivisionalPromotionComponent implements OnInit {
  @Input() divisionalPromotion: SellerShowcaseDivisionalPromotion;
  @Input() sectionHeaders: SortableSectionHeader[];
  @Input() isOnline: boolean;
  @Input() pricingDisabled: boolean;

  @Output()
  updateExpansionEventEmitter: EventEmitter<DivisionalPromotionExpansionClickData> =
    new EventEmitter();
  @Output()
  updateSortEventEmitter: EventEmitter<any> = new EventEmitter();
  @Output()
  ellipsisClickEmitter: EventEmitter<DivisionalPromotionProductClickData> =
    new EventEmitter();
  @Output()
  promotionalProductClickEmitter: EventEmitter<DivisionalPromotionProductClickData> =
    new EventEmitter();
  @Output() changeQuantityEmitter =
    new EventEmitter<DivisionalPromotionEventData>();

  selectedHeaderName: string;
  usfProductCardModeEnum = UsfProductCardModeEnum;
  disabledHeaders: SortableSectionHeader[];

  constructor(readonly platformService: PlatformService) {}

  ngOnInit(): void {
    this.setSelectedHeader();
    this.setDisabledHeaders();
  }

  setSelectedHeader() {
    if (!!this.divisionalPromotion?.sortBy) {
      this.selectedHeaderName = this.divisionalPromotion.sortBy.headerName;
      this.sectionHeaders = this.sectionHeaders.map(header =>
        header?.headerName === this.selectedHeaderName
          ? {
              ...header,
              sortDirection: this.divisionalPromotion.sortBy.sortDirection,
            }
          : header,
      );
    }
  }

  setDisabledHeaders() {
    this.disabledHeaders = this.sectionHeaders.filter(
      header =>
        header.headerName === DivisionalPromotionSectionHeaders.quantity,
    );
  }

  handleUpdateExpansionEvent() {
    this.divisionalPromotion = {
      ...this.divisionalPromotion,
      isExpanded: !this.divisionalPromotion?.isExpanded,
    };
    const expansionEvent: DivisionalPromotionExpansionClickData = {
      divisionalPromotion: this.divisionalPromotion,
    };

    this.updateExpansionEventEmitter.emit(expansionEvent);
  }

  handleUpdateSortEvent(event: any) {
    if (!event?.headerName || !event?.sortDirection) {
      return;
    }

    this.divisionalPromotion = {
      ...this.divisionalPromotion,
      sortBy: {
        headerName: event.headerName,
        sortDirection: event.sortDirection,
      },
    };

    let sortEvent: DivisionalPromotionSortingClickData = {
      divisionalPromotion: this.divisionalPromotion,
    };

    this.updateSortEventEmitter.emit(sortEvent);
  }

  handleEllipsisClick(
    event: any,
    promotionalProduct: DivisionalPromotionProduct,
  ) {
    this.ellipsisClickEmitter.emit({
      event,
      isTouch:
        this.platformService.platformType !==
        this.platformService.platformEnum.desktop,
      promotionalProduct,
    });
  }

  handleProductClick(
    promotionalProduct: DivisionalPromotionProduct,
    merchRank: number,
    isImageClick: boolean,
  ) {
    this.promotionalProductClickEmitter.emit({
      promotionalProduct,
      merchRank,
      isImageClick,
    });
  }

  handleQuantityChange(
    event: QuantityUpdate,
    promotionalProduct: DivisionalPromotionProduct,
  ) {
    this.changeQuantityEmitter.emit({ event, promotionalProduct });
  }

  trackByProductNumber = (index: number, product: DivisionalPromotionProduct) =>
    `${index}-${product?.productNumber}`;
}
